import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, useCallback } from 'react';
import '../DetailTabs/DetailTabs.css';
const ScrollSpyTabs = ({ sections, scrollOffset = 130, children, }) => {
    const [activeSection, setActiveSection] = useState(sections[0]?.id || '');
    const sectionsRef = useRef({});
    useEffect(() => {
        const handleScroll = () => {
            const vh = window.innerHeight;
            let current = sections[0]?.id || '';
            let maxVis = 0;
            for (const s of sections) {
                const el = sectionsRef.current[s.id];
                if (!el)
                    continue;
                const r = el.getBoundingClientRect();
                const vis = Math.max(0, Math.min(vh, r.bottom) - Math.max(0, r.top));
                if (vis > maxVis && r.top < vh * 0.5) {
                    maxVis = vis;
                    current = s.id;
                }
            }
            setActiveSection(current);
        };
        let ticking = false;
        const throttled = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    handleScroll();
                    ticking = false;
                });
                ticking = true;
            }
        };
        window.addEventListener('scroll', throttled, { passive: true });
        handleScroll();
        return () => window.removeEventListener('scroll', throttled);
    }, [sections]);
    const handleTabClick = useCallback((id) => {
        const el = sectionsRef.current[id];
        if (el) {
            const top = window.scrollY + el.getBoundingClientRect().top - scrollOffset;
            window.scrollTo({ top, behavior: 'smooth' });
            setActiveSection(id);
        }
    }, [scrollOffset]);
    const registerRef = useCallback((id) => (el) => {
        sectionsRef.current[id] = el;
    }, []);
    return (_jsxs("div", { className: "detail-tabs-container", children: [_jsx("div", { className: "tabs-nav-fixed", children: _jsx("div", { className: "tabs-nav-wrapper", children: sections.map((s) => (_jsxs("button", { className: `tab-button ${activeSection === s.id ? 'active' : ''}`, onClick: () => handleTabClick(s.id), children: [_jsx("span", { className: "tab-icon", children: s.icon }), _jsx("span", { className: "tab-label", children: s.label })] }, s.id))) }) }), _jsx("div", { className: "tabs-content-scroll", children: children(registerRef) })] }));
};
export default ScrollSpyTabs;
